import { Cpu, Clapperboard, UtensilsCrossed, ShoppingBag, Car, HeartPulse, Landmark, Zap, MessagesSquare, Candy, Trophy, PawPrint, Tag } from "lucide-react";

const ICONS = {
  tech: Cpu,
  entertainment: Clapperboard,
  food: UtensilsCrossed,
  shopping: ShoppingBag,
  cars: Car,
  health: HeartPulse,
  banking: Landmark,
  energy: Zap,
  social: MessagesSquare,
  snacks: Candy,
  sports: Trophy,
  pets: PawPrint,
};

export const CategoryIcon = ({ id, size = 22 }) => {
  const Icon = ICONS[id] || Tag;
  return <Icon size={size} strokeWidth={2} data-testid={`category-icon-${id}`} />;
};
